// @mui
import { Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

//
import type { BreadcrumbsLinkProps } from './types';

// ----------------------------------------------------------------------

type Props = {
  activeLast?: boolean;
  disabled: boolean;
  link: BreadcrumbsLinkProps;
};

const BreadcrumbsLink = ({ activeLast, disabled, link }: Props) => {
  const { href, icon, name } = link;

  const styles = {
    alignItems: 'center',
    color: 'text.primary',
    display: 'inline-flex',
    ...(disabled &&
      !activeLast && {
        color: 'text.disabled',
        cursor: 'default',
        pointerEvents: 'none',
      }),
  };

  const renderContent = (
    <>
      {icon && (
        <Box
          component="span"
          sx={{
            '& svg': { height: 20, width: 20 },
            display: 'inherit',
            mr: 1,
          }}
        >
          {icon}
        </Box>
      )}

      {name}
    </>
  );

  if (href) {
    return (
      <Link component={RouterLink} sx={styles} to={href}>
        {renderContent}
      </Link>
    );
  }

  return <Box sx={styles}> {renderContent} </Box>;
};

export default BreadcrumbsLink;
